import SinglePage from "../SinglePage/SinglePage";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import TopicIntro from "../../base/Topic/TopicIntro";
import CommiteeProfileCard from "./CommiteeProfileCard/CommiteeProfileCard";
import { Container } from "./styles";
import { CommiteeProfileCardProps } from "./CommiteeProfileCard/CommiteeProfileCard";
import { useRef } from 'react';
import {smoothScrollTo} from "../../functionallity/smoothScrollTo";

const commiteeMembers: CommiteeProfileCardProps[] = [
    {
        name: "Marvin Werner",
        job: "1. Vorstand"
    },
    {
        name: "Yvonne Özer",
        job: "2. Vorstand"
    },
    {
        name: "Marc Jäckle",
        job: "1. Oberhexe"
    },
    {
        name: "Max Haas",
        job: "2. Oberhexe"
    },
    {
        name: "Christoph Wilk",
        job: "1. Kassierer"
    },
    {
        name: "Idgie Fisher",
        job: "2. Kassierer"
    },
    {
        name: "Fabio Lionti",
        job: "1. Fest- und Zeugwart"
    },
    {
        name: "Martin Seckinger",
        job: "2. Fest- und Zeugwart"
    },
    {
        name: "Melissa Kaletsch-Evcek",
        job: "Schriftführer"
    },
    {
        name: "Verena Flaig",
        job: "Kleidleswart"
    },
    {
        name: "Petra Scholz",
        job: "Beisitzer "
    }
]

const Elders = () => {
    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };

    return (
        <SinglePage
            title='Ältesten'
            heroBanner={
                <HeroBanner 
                imageSource = {require('../../../assets/images/Elders/2025_sbg_1.jpg')}
                headline="DIE ÄLTESTEN."
                text="Tritt näher und lerne unseren Ausschuss kennen." 
                onNextSection={scrollToTopicIntro}
                />
            }
            topic={
                <div ref={topicIntroRef}>
                    <TopicIntro
                    headline="DIE ÄLTESTEN."
                    introductionText="Hier stellen wir euch die Köpfe hinter den Eckenmoorhexen vor: 
                    die Ausschussmitglieder. Mit Herzblut und Engagement sorgen sie dafür, 
                    dass im Verein alles rund läuft und die Fasnet ein voller Erfolg wird. Lernt hier jedes Ausschussmitglied 
                    und seine Rolle im Verein kennen!"
                    />
                </div>
            }
            content={
                <>
                    <Container>
                        {commiteeMembers.map((member, index) => (
                            <CommiteeProfileCard key={index} name={member.name} job={member.job}/>
                        ))}
                    </Container>
                </>
            }
            >
        </SinglePage>
    );
}
 
export default Elders;